import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { GiFairyWings } from "react-icons/gi";
import { FaFilePdf } from "react-icons/fa";
import "./AnnualReport.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:5000";

function AnnualReport() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/annual-reports/public`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setReports(data);
        }
      } catch (error) {
        console.error("Failed to fetch annual reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  if (loading) {
    return <div className="report-page-loading">Loading Annual Reports...</div>;
  }

  return (
    <>
      <Helmet>
        <title>Annual Reports | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="View and download annual reports for Rajput Shiksha Kosh."
        />
      </Helmet>

      <div className="report-page-wrapper">
        <div className="report-page-container">

          {/* HEADER */}
          <div className="report-page-header">
            <h1 className="report-page-title">
              Annual Reports
            </h1>

            <div className="report-page-divider">
              <span className="report-page-line"></span>
              <GiFairyWings className="report-page-icon" />
              <span className="report-page-line"></span>
            </div>
          </div>

          {/* GRID OF PDF REPORTS */}
          {reports.length > 0 ? (
            <div className="report-page-grid">
              {reports.map((report) => {
                const pdfUrl = `${API_BASE_URL}${report.pdf}`;
                return (
                  <a 
                    key={report._id} 
                    href={pdfUrl} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="report-page-card"
                  >
                    <div className="report-page-icon-wrapper">
                      <div className="report-page-pdf-icon-container">
                        <FaFilePdf className="report-page-pdf-icon" />
                      </div>
                    </div>

                    <div className="report-page-content">
                      <h2 className="report-page-card-title" title={report.title}>
                        {report.title}
                      </h2>
                    </div>
                  </a>
                );
              })}
            </div>
          ) : (
            <div className="report-page-empty">
              No annual reports are available at the moment.
            </div>
          )}

        </div>
      </div>
    </>
  );
}

export default AnnualReport;